import { createRouter, createWebHistory } from 'vue-router'
import home from '@/views/home/home.vue'
import about from '@/views/about/about.vue'
import contact from '@/views/contact/contact.vue'
import partners from '@/views/partners/partners.vue'
import products from '@/views/products/products.vue'
import privacyPolicy from '@/views/privacyPolicy/privacyPolicy.vue'

const routes = [
  {
    name: 'home',
    path: '/home',
    component: home,
    meta: {}
  },
  {
    name: 'about',
    path: '/about',
    component: about,
    meta: {}
  },
  {
    name: 'contact',
    path: '/contact',
    component: contact,
    meta: {}
  },
  {
    name: 'partners',
    path: '/partners',
    component: partners,
    meta: {}
  },
  {
    name: 'products',
    path: '/products',
    component: products,
    meta: {}
  },
  {
    name: 'privacyPolicy',
    path: '/privacyPolicy',
    component: privacyPolicy,
    meta: {}
  },
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/home'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
